import { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { message } from 'antd'

export default function Detail() {
  const { oid, code } = useParams()
  const navigate = useNavigate()
  const [assessmentData, setAssessmentData] = useState({})
  const [formStatus, setFormStatus] = useState(0)
  const [showPopup, setShowPopup] = useState(false)
  const [formData, setFormData] = useState({
    name: '',
    idNumber: '',
    phone: '',
    college: '',
    major: ''
  })

  useEffect(() => {
    axios.post('/c/assessment/detail/get', {
      code: code,
    })
      .then(function (response) {
        if (response.errcode === 0) {
          document.title = response.data.name + ' - 职业生涯测评'
          setAssessmentData(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
    axios.post('/c/assessment/config/get', {
      merchant_oid: oid,
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setFormStatus(response.data.form_status)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }, [code, oid])

  const handleStartTest = () => {
    if (formStatus === 3) {
      navigate(`/testing/${oid}/${code}`)
    } else {
      setShowPopup(true)
    }
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (!formData.name.trim()) {
      message.warning('请输入姓名')
      return
    }
    if (!formData.idNumber.trim()) {
      message.warning('请输入身份证号')
      return
    }
    if (!formData.phone.trim()) {
      message.warning('请输入手机号')
      return
    }
    if (!formData.college.trim()) {
      message.warning('请输入学院')
      return
    }
    if (!formData.major.trim()) {
      message.warning('请输入专业')
      return
    }
    const phoneRegex = /^1[3-9]\d{9}$/
    if (!phoneRegex.test(formData.phone)) {
      message.warning('请输入正确的手机号码')
      return
    }
    const idRegex = /(^\d{15}$)|(^\d{17}([0-9]|[Xx])$)/
    if (!idRegex.test(formData.idNumber)) {
      message.warning('请输入正确的身份证号码')
      return
    }
    navigate(`/testing/${oid}/${code}`, { state: { formData } })
  }

  return (
    <div className='detail-page'>
      <img className='detail-bg' src='/images/detail-bg.png' alt="" />
      <div className='detail-name'>
        <img src='/images/detail-name-bg.png' alt="" />
        <span>{assessmentData.name}</span>
      </div>

      <div className='detail-content'>
        <h2 className='detail-title'>测评说明：</h2>
        <p className='detail-description'>{assessmentData.description}</p>
      </div>
            
      <div className='detail-button' onClick={handleStartTest}>开始测试</div>

      {showPopup && (
        <div className="detail-popup-overlay">
          <div className="detail-popup-container">
            <img 
              src="/images/guanbi.png" 
              alt="close" 
              className="detail-popup-close"
              onClick={() => setShowPopup(false)}
            />
            <div className="detail-popup-content">
              <h3 className="detail-popup-title">信息填写</h3>
              <form onSubmit={handleSubmit} className="detail-popup-form">
                <div className="detail-form-group">
                  <div className="detail-input-container">
                    <img src="/images/name.png" alt="name" className="detail-input-icon" />
                    <input
                      type="text"
                      name="name"
                      placeholder='请输入姓名'
                      value={formData.name}
                      onChange={handleInputChange}
                      className="detail-form-input"
                    />
                  </div>
                </div>
                
                <div className="detail-form-group">
                  <div className="detail-input-container">
                    <img src="/images/idNumber.png" alt="id" className="detail-input-icon" />
                    <input
                      type="text"
                      name="idNumber"
                      placeholder='请输入身份证号'
                      value={formData.idNumber}
                      onChange={handleInputChange}
                      className="detail-form-input"
                    />
                  </div>
                </div>
                
                <div className="detail-form-group">
                  <div className="detail-input-container">
                    <img src="/images/phone.png" alt="phone" className="detail-input-icon" />
                    <input
                      type="tel"
                      name="phone"
                      placeholder='请输入手机号'
                      value={formData.phone}
                      onChange={handleInputChange}
                      className="detail-form-input"
                    />
                  </div>
                </div>
                
                <div className="detail-form-group">
                  <div className="detail-input-container">
                    <img src="/images/college.png" alt="college" className="detail-input-icon" />
                    <input
                      type="text"
                      name="college"
                      placeholder='请输入学院'
                      value={formData.college}
                      onChange={handleInputChange}
                      className="detail-form-input"
                    />
                  </div>
                </div>
                
                <div className="detail-form-group">
                  <div className="detail-input-container">
                    <img src="/images/major.png" alt="major" className="detail-input-icon" />
                    <input
                      type="text"
                      name="major"
                      placeholder='请输入专业'
                      value={formData.major}
                      onChange={handleInputChange}
                      className="detail-form-input"
                    />
                  </div>
                </div>
                
                <div className="detail-form-actions">
                  <button type="submit" className='detail-popup-button1'>确认</button>
                  {formStatus === 2 && 
                    <button type="button" className='detail-popup-button2' onClick={() => navigate(`/testing/${oid}/${code}`)}>
                      跳过
                    </button>
                  }
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
